module.exports = __webpack_public_path__ + "static/media/search.66170ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.svg
// module id = 100
// module chunks = 0